<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <contentheading
        :button="$t('blacklists.add')"
        :title="$t('blacklists.list')"
        url="blacklist_add"/>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search"/>
                <div class="table-responsive">
                    <table class="table table-striped dataTable my-4 w-100" id="blacklists">
                      <thead>
                        <tr>
                          <th>
                            <div class="checkbox c-checkbox">
                              <label class="mb-0 p">
                                <input class="select-box" type="checkbox" v-model="selectAll">
                                <span class="fa fa-check"></span>
                              </label>
                            </div>
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__code',
                              'sorting_desc': ordering === '-part__code'}"
                            @click="order('part__code')">{{ $t('blacklists.code') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__name',
                              'sorting_desc': ordering === '-part__name'}"
                            @click="order('part__name')">{{ $t('blacklists.name') }}
                          </th>
                          <th>{{ $t('blacklists.producer') }}</th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'creator__name',
                              'sorting_desc': ordering === '-creator__name'
                            }"
                            @click="order('creator__name')">{{ $t('blacklists.creator') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'created',
                              'sorting_desc': ordering === '-created'}"
                            @click="order('created')">{{ $t('blacklists.created') }} / <span class="text-muted font-italic">{{ $t('blacklists.updated') }}</span>
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'is_active',
                              'sorting_desc': ordering === '-is_active'}"
                            @click="order('is_active')">{{ $t('blacklists.status') }}
                          </th>
                          <th class="wd-xs"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
                          <td>
                            <div class="checkbox c-checkbox">
                              <label class="mb-0">
                                <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                                <span class="fa fa-check"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                              {{ row.part_code }}
                          </td>
                          <td>{{ row.part_name }}
                            <button
                              class="btn btn-link pl-1 pt-1"
                              @click="open_modal(row.part_name, row.part_codes_tags)"
                              v-if="row.part_codes_tags"
                            >
                              <i class="fa icon-info ml-1"></i>
                            </button>
                          </td>
                          <td>{{ row.producers_tags }}</td>
                          <td>{{ row.creator_name }}</td>
                          <td>
                            {{ row.created | formatDateTime }}
                            <span
                              v-if="format_date_time(row.created) !== format_date_time(row.updated)"
                              class="text-muted font-italic small"><br>{{ row.updated | formatDateTime }}
                            </span>
                          </td>
                          <td>{{ row.is_active ? 'Active': 'Disabled' }}</td>
                          <td>
                            <div class="btn-group">
                              <router-link
                                :to="{name: 'blacklist_edit', params: {id: row.id}}"
                                :title="$t('blacklists.button-edit')"
                                class="far fa-edit btn btn-link link-unstyled px-1 py-2 text-info"
                              />
                              <button
                                class="btn btn-link p-1 text-info"
                                :title="$t('blacklists.button-delete')"
                                @click="remove_blacklist(row.id, index)">
                                <i class="far fa-trash-alt"></i>
                              </button>
                              <button
                                class="btn btn-link link-unstyled p-1 text-info"
                                :title="$t('blacklists.show-comments')"
                                @click="open_comments_modal(row)"
                                data-toggle="modal"
                                data-target="#commentsModal">
                                <i class="far fa-comments text-info"></i>
                                <span class="text-info pl-1">{{row.comments.length}}</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="showModal">
      <h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
      <div class="modal-body" slot="modal-body">
        <p class="text-bold">{{ $t('modal.section1.header') }}</p>
        <p>{{ modal_data_1 }}</p>
        <p class="text-bold">{{ $t('modal.section2.header') }}</p>
        <p>{{ modal_data_2}}</p>
      </div>
      <div slot="modal_buttons">
        <button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
      </div>
    </modal>
    <modal v-if="showModalComments">
      <h4 class="modal-title" slot="header-text">{{ $t('blacklists.comments-title') }}</h4>
      <div class="modal-body pre-scrollable" slot="modal-body">
        <div class="form-group">
          <label class="text-bold m-0">{{ $t('blacklists.part-title') }}:</label>
          <p class="form-control-plaintext">
            {{ row.part_code }}
          {{ row.part_name }}
          </p>
          <label class="text-bold m-0">{{ $t('blacklists.producers-in-blacklist') }}:</label>
          <p class="form-control-plaintext">
             <span class="text-black-50">{{row.producers_tags}}</span>
          </p>
          <h5 class="mt-2 text-bold"> {{ $t('blacklists.comments-log') }}</h5>
        </div>
        <div class="form-group" v-for="(c, index) in row.comments"
        :key="'comment_' + index">
          <hr>
          <p class="form-control-plaintext">
             <span class="text-bold">{{c.name}}</span>
             <span class="text-muted">{{c.created | formatDateTime}} </span>
          </p>
          <p class="form-control-plaintext">
            <span v-if="c.added_producers" class="text-success">{{ $t('blacklists.added-producers')}}</span>
            <span v-if="c.added_producers" class="text-black-50">{{c.added_producers}}</span>
            <br v-if="c.added_producers">
            <span v-if="c.removed_producers" class="text-danger">{{ $t('blacklists.removed-producers')}}</span>
            <span v-if="c.removed_producers" class="text-black-50">{{c.removed_producers}}</span>
            <br v-if="c.removed_producers">
            <span v-if="c.black_list_deactivated" class="text-info"> {{ $t('blacklists.blacklist-deactivated') }}</span>
            <span v-if="c.black_list_activated" class="text-green">{{ $t('blacklists.blacklist-activated') }}</span>
          </p>
          <p class="form-control-plaintext">{{c.content}}</p>
        </div>
      </div>
      <div slot="modal_buttons">
        <button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
      </div>
    </modal>

  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import message from '@/message'
import moment from 'moment'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'
import Modal from '@/components/Modal.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'name'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/black_lists/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size
    }
  })
    .then(resp => {
      let rowsData = []
      let rows = resp.data.results
      let created = ''
      let updated = ''
      let createdUpdated = ''

      rows.forEach(row => {
        created = moment(String(row.created)).format('DD.MM.YYYY HH:mm')
        updated = moment(String(row.updated)).format('DD.MM.YYYY HH:mm')
        createdUpdated = created
        if (created !== updated) {
          createdUpdated += ' / ' + updated
        }

        rowsData.push({
          0: row.id,
          1: row.part_code,
          2: row.part_name,
          3: row.producers_tags,
          4: row.creator_name,
          5: createdUpdated,
          6: row.is_active ? 'Active' : 'Disabled'
        })
      })

      next({
        rows: rows,
        rowsData: rowsData,
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    datatablebuttons: Datatablebuttons,
    pagination: Pagination,
    search: Search,
    modal: Modal
  },
  data () {
    return {
      rows: [],
      rowsData: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      page_size: null,
      showModal: false,
      selected: [],
      modal_data_1: null,
      modal_data_2: null,
      columns: [
        'Kood',
        'Nimetus',
        'Tootja',
        'Koostas',
        'Loodud / Uuendatud',
        'Staatus'
      ],
      showModalComments: false,
      row: null
    }
  },
  mounted () {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'blacklists'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    close_modal () {
      if (this.showModal) {
        this.showModal = false
      } else if (this.showModalComments) {
        this.showModalComments = false
      }
    },
    open_modal (data1, data2) {
      this.showModal = true
      this.modal_data_1 = data1
      this.modal_data_2 = data2
    },
    close_comments_modal () {
      this.showModalComments = false
    },
    open_comments_modal (row) {
      this.showModalComments = true
      this.row = row
    },
    remove_blacklist (id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('blacklists.are-you-sure'),
        text: this.$i18n.t('blacklists.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.patch(`/black_lists/${id}/`, {is_deleted: true, is_active: false})
              .then(() => {
                message.success(this.$i18n.t('blacklists.deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('blacklists.forbidden'))
              })
          }
        })
    },
    format_date_time (dt) {
      return moment(String(dt)).format('DD.MM.YYYY HH:mm')
    },
    order (o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate (p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Blacklists.vue